import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Select,
  format_date,
  GET,
  PUT,
  UPLOAD,
  t,
  can,
} from "../../components/CustomComponent.js";
import {
  DEFAULT_WATERMARK,
  EMPTY_COMPANY_BRIEF,
  WATERMARK_SOURCES,
  APPLY_TARGETS,
  POSITIONS,
  ROTATE_PRESETS,
  clone,
  digit,
} from "../../components/setting_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/settings.css";

/* ============================================================================
 * ตั้งค่า › ตั้งค่าลายน้ำ  (/ad/watermark)
 * ลายน้ำที่ติดบนรูปประกาศ : ใช้อะไรเป็นลายน้ำ ติดกับรูปไหน วางตรงไหน
 * ขนาดเท่าไร และจางแค่ไหน — ปรับแล้วเห็นผลทันทีที่กล่องพรีวิวด้านขวา
 * โลโก้ที่ใช้เป็นลายน้ำดึงมาจากหน้า "ข้อมูลบริษัท" (/ad/settings)
 *
 * ต่อกับ API แล้ว :
 *   GET  admin/settings             (Get — ได้ทั้งลายน้ำและข้อมูลบริษัทสำหรับพรีวิว)
 *   PUT  admin/settings/watermark   (Save — ส่งเฉพาะส่วนลายน้ำ)
 * รูปลายน้ำที่เพิ่งเลือกจากเครื่องถูกอัปขึ้น R2 ตรง ๆ ผ่าน presigned URL ตอนกดบันทึก (UPLOAD)
 * แล้วส่งไปกับ body แค่ URL — ตัวไฟล์ไม่เคยวิ่งผ่าน API ครั้งต่อไปส่ง URL เดิมกลับไป ไม่อัปซ้ำ
 * ========================================================================== */

const WATERMARK_FOLDER = "watermark";
const MAX_WATERMARK_SIZE = 2 * 1024 * 1024; // 2MB

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

// ค่าว่างของ text/image ถูก services/api ตัดทิ้งก่อนส่ง ถ้าตั้งใจล้างค่าต้องส่ง "-"
const clearable = (value) => (String(value || "").trim() ? String(value).trim() : "-");

// ช่องตัวเลขที่ถูกลบจนว่างให้กลับไปใช้ค่าตั้งต้น จะได้ไม่โดนตัดทิ้งแล้วค้างค่าเดิมไว้
const numeric = (value, key) => (String(value ?? "") === "" ? DEFAULT_WATERMARK[key] : String(value));

export default class WatermarkSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: clone(DEFAULT_WATERMARK),  // ค่าที่กำลังแก้
      saved: clone(DEFAULT_WATERMARK), // ค่าที่บันทึกไว้ล่าสุด (ไว้เทียบว่ามีแก้ค้างไหม)
      company: clone(EMPTY_COMPANY_BRIEF), // อ่านอย่างเดียว — ใช้โลโก้/ชื่อมาโชว์บนพรีวิว
      updated_at: null,
      updated_by: "",
    };
    // ไฟล์ลายน้ำที่เพิ่งเลือก รออัปขึ้น R2 ตอนกดบันทึก (ไม่เก็บใน state เพราะไม่ต้อง re-render)
    this.imageFile = null;
    this.imagePreview = "";
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  componentWillUnmount() {
    this.clearPickedImage();
  }

  // คืนหน่วยความจำของ object URL ที่สร้างไว้พรีวิว
  clearPickedImage = () => {
    if (this.imagePreview) URL.revokeObjectURL(this.imagePreview);
    this.imageFile = null;
    this.imagePreview = "";
  };

  /* ------------------------------------------------------------ ดึงค่าตั้งค่า */
  Get = async () => {
    loading(true);
    const result = await GET("admin/settings");
    loading(false);

    if (!result?.status) return;

    this.applyResult(result.data);
  };

  // ใช้ค่าที่ backend ตอบกลับเป็นค่าล่าสุดเสมอ (รูปลายน้ำจะกลายเป็น URL หลังบันทึก)
  // "แก้ล่าสุด" ของหน้านี้เป็นคนละชุดกับของหน้าข้อมูลบริษัท เพราะอยู่คนละตาราง
  applyResult = (data) => {
    const watermark = { ...DEFAULT_WATERMARK, ...(data?.watermark || {}) };

    // ไฟล์ที่ค้างอยู่ถูกอัปไปแล้ว (หรือถูกโหลดทับ) ทิ้งพรีวิวชั่วคราวได้
    this.clearPickedImage();

    this.setState({
      data: clone(watermark),
      saved: clone(watermark),
      company: { ...EMPTY_COMPANY_BRIEF, ...(data?.company || {}) },
      updated_at: data?.watermark_updated_at || null,
      updated_by: data?.watermark_updated_by || "",
    });
  };

  set = (key, value) => this.setState((prev) => ({ data: { ...prev.data, [key]: value } }));

  isDirty = () => JSON.stringify(this.state.data) !== JSON.stringify(this.state.saved);

  /* ---------------------------------------------------------- เลือกไฟล์รูป */
  // เก็บตัวไฟล์ไว้ก่อน พรีวิวด้วย object URL (ไม่แปลงเป็น base64 เพราะไม่ต้องส่งผ่าน body)
  PickImage = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (file.size > MAX_WATERMARK_SIZE) return alert("", "warning", t("warning"), t("verify_logo_size"));

    this.clearPickedImage();
    this.imageFile = file;
    this.imagePreview = URL.createObjectURL(file);
    this.set("image", this.imagePreview);
  };

  /* ------------------------------------------------------------ บันทึก/คืนค่า */
  Save = async () => {
    const { data } = this.state;

    if (data.enabled && data.source === "text" && !data.text.trim())
      return alert("", "warning", t("warning"), t("verify_watermark_text"));
    if (data.enabled && data.source === "custom" && !data.image)
      return alert("", "warning", t("warning"), t("verify_watermark_image"));

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);

    // อัปรูปลายน้ำขึ้น R2 ก่อน แล้วค่อยส่งเฉพาะ URL ไปกับ body
    // (ค่าใน data.image ตอนนี้เป็น object URL ของเครื่อง ส่งไป backend ใช้ไม่ได้)
    let image = data.image;
    if (this.imageFile) {
      const uploaded = await UPLOAD(this.imageFile, { folder: WATERMARK_FOLDER });
      if (!uploaded?.status) {
        loading(false);
        return alert("", "warning", t("warning"), `${t("upload_failed")}\n${uploaded?.message || ""}`.trim());
      }
      image = uploaded.data.file_path;

      // ไฟล์ขึ้น R2 แล้ว เก็บ URL จริงแทน object URL ทันที
      // ถ้า PUT ข้างล่างพลาดแล้วผู้ใช้กดบันทึกซ้ำ จะได้ไม่อัปไฟล์เดิมขึ้นไปอีกรอบ
      this.clearPickedImage();
      this.setState((prev) => ({ data: { ...prev.data, image } }));
    }

    // รูปที่อัปไว้แล้วส่งกลับไปทั้ง URL เดิม (ไม่อัปซ้ำ) และไม่ล้างทิ้งตอนสลับที่มาของลายน้ำ
    // เผื่อผู้ใช้สลับกลับมาใช้รูปเดิม
    const payload = {
      ...data,
      text: clearable(data.text),
      image: clearable(image),
      rotate: numeric(data.rotate, "rotate"),
      size: numeric(data.size, "size"),
      opacity: numeric(data.opacity, "opacity"),
      margin: numeric(data.margin, "margin"),
    };

    const result = await PUT("admin/settings/watermark", payload);
    loading(false);

    if (!result?.status) return;

    this.applyResult(result.data);
    alert("", "success", t("success"), t("save_settings_done"));
  };

  Reset = async () => {
    if (!this.isDirty()) return;
    if (!(await alert("", "warning", t("reset_changes"), t("discard_changes_confirm"), t("confirm"), t("cancel")))) return;
    this.clearPickedImage();
    this.setState((prev) => ({ data: clone(prev.saved) }));
  };

  /* ======================================================= ตัวช่วย render */
  field = (label, control, { hint = "" } = {}) => (
    <>
      <label className="prop-label">{label}</label>
      {control}
      {!!hint && <div className="ppl-sub mt-1">{hint}</div>}
    </>
  );

  number = (key, unit, { max } = {}) => (
    <div className="set-affix">
      <input
        type="text"
        className="prop-field"
        value={this.state.data[key]}
        onChange={(e) => {
          const value = e.target.value;
          if (!digit(value)) return;
          if (max !== undefined && Number(value) > max) return;
          this.set(key, value);
        }}
      />
      <span className="set-affix__unit">{unit}</span>
    </div>
  );

  range = (key, { min = 0, max = 100 } = {}) => (
    <input
      type="range"
      className="set-range"
      min={min}
      max={max}
      value={this.state.data[key]}
      onChange={(e) => this.set(key, e.target.value)}
    />
  );

  select = (key, options) => (
    <Select
      className="prop-field prop-select"
      default={false}
      placeholder={t("select")}
      value={this.state.data[key]}
      options={options.map((item) => ({ value: item.value, label: t(item.label) }))}
      onChange={(value) => value && this.set(key, value)}
    />
  );

  section = (icon, title, desc, children) => (
    <div className="ppl-section">
      <div className="ppl-section__title">
        <span className="icon">{icon}</span>
        {title}
      </div>
      <div className="ppl-section__desc">{desc}</div>
      {children}
    </div>
  );

  /* ------------------------- แปลงค่าที่ตั้งไว้เป็น style ของลายน้ำบนพรีวิว */
  markStyle = (isText) => {
    const { data } = this.state;
    const margin = `${data.margin || 0}px`;
    const [vertical, horizontal] = data.position.split("_");

    const style = {
      // แบบข้อความปล่อยให้กว้างตามตัวอักษร ไม่งั้นตัวหนังสือจะล้นกรอบที่บังคับความกว้างไว้
      width: isText ? "auto" : `${data.size}%`,
      maxWidth: "82%",
      opacity: Number(data.opacity || 0) / 100,
    };

    // ลำดับ transform : ขยับเข้าตำแหน่งก่อน แล้วค่อยหมุนรอบจุดกึ่งกลางของตัวลายน้ำ
    const transform = [];

    if (vertical === "top") style.top = margin;
    else if (vertical === "bottom") style.bottom = margin;
    else {
      style.top = "50%";
      transform.push("translateY(-50%)");
    }

    if (horizontal === "left") style.left = margin;
    else if (horizontal === "right") style.right = margin;
    else {
      style.left = "50%";
      transform.push("translateX(-50%)");
    }

    // ตำแหน่งกึ่งกลางจริง ๆ ต้องเลื่อนกลับทั้งสองแกนพร้อมกัน
    if (data.position === "center") transform.splice(0, transform.length, "translate(-50%, -50%)");

    const rotate = Number(data.rotate || 0);
    if (rotate) transform.push(`rotate(${rotate}deg)`);

    style.transform = transform.join(" ");
    return style;
  };

  /* ================================================ render : กล่องพรีวิว */
  renderPreview = () => {
    const { data, company } = this.state;
    const image = data.source === "custom" ? data.image : company.logo;
    const isText = data.source === "text" || !image;

    return (
      <div className="prop-card prop-in" style={{ position: "sticky", top: "82px" }}>
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("watermark_preview")}
          </span>
          <span className={`ppl-pill ${data.enabled ? "ppl-pill--on" : "ppl-pill--off"}`}>
            <span className="ppl-pill__dot" />
            {data.enabled ? t("active") : t("inactive")}
          </span>
        </div>

        <div className="p-3">
          <div className="set-wm">
            <span className="set-wm__ghost icon">{"\uf03e"}</span>
            <span className="set-wm__scrim" />
            <span className="set-wm__tag">{t("sample_photo")}</span>

            {data.enabled && (
              <span className="set-wm__mark" style={this.markStyle(isText)}>
                {isText ? (
                  <span className="set-wm__text" style={{ fontSize: `${Math.max(10, Number(data.size) * 0.7)}px` }}>
                    {data.source === "text" ? data.text || "SafeSpace Life Living" : company.name_en || "SafeSpace Life Living"}
                  </span>
                ) : (
                  <img src={image} alt="watermark" />
                )}
              </span>
            )}

            {!data.enabled && <span className="set-wm__off">{t("watermark_off_hint")}</span>}
          </div>

          <div className="ppl-sub mt-3">{t("watermark_preview_hint")}</div>

          {/* สรุปค่าที่ตั้งไว้ อ่านรวดเดียวจบ */}
          <div className="mt-3 d-flex flex-wrap gap-2">
            <span className="set-sample">
              {t("watermark_position")} <b>{t(POSITIONS.find((e) => e.value === data.position)?.label)}</b>
            </span>
            <span className="set-sample">
              {t("watermark_size")} <b>{data.size}%</b>
            </span>
            <span className="set-sample">
              {t("watermark_opacity")} <b>{data.opacity}%</b>
            </span>
            <span className="set-sample">
              {t("watermark_rotate")} <b>{data.rotate}\u00b0</b>
            </span>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { data, updated_at, updated_by } = this.state;
    const dirty = this.isDirty();

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          {/* หัวข้อหน้า */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("watermark_setting")}</h3>
              <div className="text-secondary text-14">{t("watermark_page_desc")}</div>
            </div>
            <div className="text-secondary text-12 text-lg-end">
              {!!updated_at && (
                <div>
                  {t("updated")} {format_date(updated_at, "dd mmm yyyy hh:mm", locale())}
                </div>
              )}
              {!!updated_by && (
                <div>
                  {t("updated_by")} {updated_by}
                </div>
              )}
            </div>
          </div>

          <div className="row g-3">
            {/* ค่าที่ตั้งได้ */}
            <div className="col-xl-7 col-lg-7">
              <div className="prop-card prop-in">
                <div className="p-4">
                  {this.section(
                    "\uf03e",
                    t("watermark_source_section"),
                    t("watermark_setting_desc"),
                    <>
                      <div className="set-row mb-3">
                        <div className="min-w-0">
                          <div className="set-row__title">{t("photo_watermark")}</div>
                          <div className="set-row__desc">{t("photo_watermark_desc")}</div>
                        </div>
                        <label className="ppl-switch">
                          <input type="checkbox" checked={data.enabled} onChange={(e) => this.set("enabled", e.target.checked)} />
                          <span className="ppl-switch__track" />
                        </label>
                      </div>

                      <div className="row g-3">
                        <div className="col-md-6">{this.field(t("watermark_source"), this.select("source", WATERMARK_SOURCES))}</div>
                        <div className="col-md-6">{this.field(t("watermark_apply_to"), this.select("apply_to", APPLY_TARGETS))}</div>

                        {data.source === "text" && (
                          <div className="col-12">
                            {this.field(
                              t("watermark_text"),
                              <input
                                type="text"
                                className="prop-field"
                                maxLength={40}
                                value={data.text}
                                onChange={(e) => this.set("text", e.target.value)}
                              />,
                              { hint: t("watermark_text_hint") }
                            )}
                          </div>
                        )}

                        {data.source === "custom" && (
                          <div className="col-12">
                            <label className="prop-label">{t("watermark_image")}</label>
                            <div className="d-flex align-items-center gap-3">
                              <label className="set-logo">
                                <input type="file" accept="image/png,image/svg+xml" onChange={this.PickImage} />
                                {data.image ? (
                                  <img className="set-logo__img" src={data.image} alt="watermark" />
                                ) : (
                                  <span className="set-logo__mark">PNG</span>
                                )}
                                <span className="set-logo__hint">{t("change_image")}</span>
                              </label>
                              <div className="ppl-sub">{t("watermark_image_hint")}</div>
                            </div>
                          </div>
                        )}

                        {data.source === "logo" && (
                          <div className="col-12">
                            <div className="ppl-note">
                              <span className="icon">{"\uf05a"}</span>
                              <div>
                                {t("watermark_use_logo_hint")}{" "}
                                <a href="/ad/settings" className="fw-bold" style={{ color: "#4d7c0f" }}>
                                  {t("go_company_profile")}
                                </a>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {this.section(
                    "\uf0b2",
                    t("watermark_layout"),
                    t("watermark_layout_desc"),
                    <div className="row g-4">
                      <div className="col-md-5">
                        <label className="prop-label">{t("watermark_position")}</label>
                        <div className="set-pos">
                          {POSITIONS.map((position) => (
                            <button
                              key={position.value}
                              type="button"
                              title={t(position.label)}
                              aria-pressed={data.position === position.value}
                              className={`set-pos__btn icon ${data.position === position.value ? "is-on" : ""}`}
                              onClick={() => this.set("position", position.value)}
                            >
                              {"\uf111"}
                            </button>
                          ))}
                        </div>
                        <div className="ppl-sub mt-2">{t(POSITIONS.find((e) => e.value === data.position)?.label)}</div>
                      </div>

                      <div className="col-md-7">
                        <label className="prop-label">
                          {t("watermark_size")} <span className="fw-normal text-secondary">— {data.size}%</span>
                        </label>
                        {this.range("size", { min: 5, max: 60 })}
                        <div className="ppl-sub mb-3">{t("watermark_size_hint")}</div>

                        <label className="prop-label">
                          {t("watermark_opacity")} <span className="fw-normal text-secondary">— {data.opacity}%</span>
                        </label>
                        {this.range("opacity", { min: 10, max: 100 })}
                        <div className="ppl-sub mb-3">{t("watermark_opacity_hint")}</div>

                        <label className="prop-label">
                          {t("watermark_rotate")}{" "}
                          <span className="fw-normal text-secondary">&mdash; {data.rotate}&deg;</span>
                        </label>
                        <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                          {ROTATE_PRESETS.map((preset) => (
                            <button
                              key={preset.value}
                              type="button"
                              aria-pressed={String(data.rotate) === preset.value}
                              className={`set-day ${String(data.rotate) === preset.value ? "is-on" : ""}`}
                              onClick={() => this.set("rotate", preset.value)}
                            >
                              {preset.value === "0" ? t(preset.label) : preset.label}
                            </button>
                          ))}
                        </div>
                        {this.range("rotate", { min: -90, max: 90 })}
                        <div className="ppl-sub mb-3">{t("watermark_rotate_hint")}</div>

                        <div style={{ maxWidth: "220px" }}>
                          {this.field(t("watermark_margin"), this.number("margin", "px", { max: 200 }), {
                            hint: t("watermark_margin_hint"),
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* แถบบันทึก — ตรึงท้ายกล่องให้กดได้ทันทีแม้เนื้อหายาว */}
                {/* ไม่มีสิทธิ์แก้ = ไม่ต้องมีแถบบันทึก ดูค่าที่ตั้งไว้ได้อย่างเดียว */}
                {can("watermark.update") && (
                  <div className="ppl-savebar">
                    {dirty ? (
                      <span className="ppl-dirty">
                        <span className="ppl-dirty__dot" />
                        {t("unsaved_changes")}
                      </span>
                    ) : (
                      <span className="text-secondary text-12 d-flex align-items-center gap-2">
                        <span className="icon">{"\uf058"}</span>
                        {t("all_changes_saved")}
                      </span>
                    )}

                    <div className="d-flex gap-2">
                      <button type="button" className="prop-btn prop-btn--ghost" disabled={!dirty} onClick={this.Reset}>
                        <span className="icon text-12">{"\uf0e2"}</span>
                        {t("reset_changes")}
                      </button>
                      <button type="button" className="prop-btn" disabled={!dirty} onClick={this.Save}>
                        <span className="icon text-12">{"\uf0c7"}</span>
                        {t("save_settings")}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* พรีวิว */}
            <div className="col-xl-5 col-lg-5">{this.renderPreview()}</div>
          </div>
        </div>
      </div>
    );
  }
}
